module.exports = __webpack_public_path__ + "img/user-multiple.338d7fcf.svg";